import {Loan} from "Loans/interface";

export enum Actions {
  SET_LOAN_LIST = "SET_LOAN_LIST",
  SET_LOAN_INDEX = "SET_LOAN_INDEX",
};

export function setLoanList(loans: Loan[]) {
  return {type: Actions.SET_LOAN_LIST, body: loans};
};

export function setLoanIndex(index: number) {
  sessionStorage.setItem('loanIndex', String(index));
  return {type: Actions.SET_LOAN_INDEX, body: index};
};
